import { ReactNode } from "react"

type BaseSectionHeadlineType = {
    label: string
    classProps?: string
    icon?: ReactNode
    small?: boolean
}
export default function BaseSectionHeadline(props: BaseSectionHeadlineType) {
    return (
        <div className={`border-b flex w-full justify-between mb-4 ${props.classProps}`}>
            <h3 className={`${props.small ? "text-base font-medium" : "text-xl font-bold"}`}>{props.label}</h3>
            {props.icon}
        </div>
    )
}
